import "core-js/stable"
import "regenerator-runtime/runtime"

import initialise from "./maps"
import "./dialog"

initialise()